export const DAPI_COOKIE_NAME = "dapi_random_id";

declare global {
  interface Window {
    DAPI_COOKIE_NAME: string;
  }
}

export function getDapiRandomId(): string | null {
  if (typeof document === 'undefined') return null;
  var cookieValue = document.cookie;
  var cookieRegex = new RegExp('(?:^|;\\s*)' + window.DAPI_COOKIE_NAME + '=([^;]*)');
  var cookieMatch = cookieValue.match(cookieRegex);
  return cookieMatch ? cookieMatch[1] : null;
}

export function setDapiRandomId(value: string): void {
  if (typeof document === 'undefined') return;
  var expireDate = new Date();
  expireDate.setTime(expireDate.getTime() + (7 * 24 * 60 * 60 * 1000)); // 7 days
  document.cookie = window.DAPI_COOKIE_NAME + '=' + value + '; expires=' + expireDate.toUTCString() + '; path=/; secure; samesite=strict';
}
